import Terms from "../page/Terms/Terms"
import TermsIcon from "../images/TermsIcon"
import TermsIconActive from "../images/TermsIconActive"
import TermDetail from "../page/Terms/TermDetail"
import JournalEntries from "../page/JournalEntries/JournalEntries"
import CreateJournalEntry from "../page/JournalEntries/CreateJournalEntry"
import BalanceIcon from "../images/BalanceIcon"
import GeneralReportIcon from "../images/GeneralReportIcon"
import GeneralReportIconActive from "../images/GeneralReportIconActive"
import FinancialReports from "../page/FinancialReports/FinancialReports"
import PayrollPayments from "../page/PayrollPayments/PayrollPayments"
import PayrollPaymentUpload from "../page/PayrollPayments/PayrollPaymentUpload"

const LedgerSideBar = [
    {
        index: 1,
        name: "Payment Terms",
        show: true,
        showRoute: true,
        path: "/terms",
        component: Terms,
        image: TermsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 2,
        name: "Payment Terms",
        show: false,
        showRoute: true,
        path: "/terms/new",
        component: TermDetail,
        image: TermsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 3,
        name: "Payment Terms",
        show: false,
        showRoute: true,
        path: "/terms/:id",
        component: TermDetail,
        image: TermsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 4,
        name: "Journal Entries",
        permissionName: "Journal Entries",
        show: true,
        showRoute: true,
        path: "/journal-entries",
        component: JournalEntries,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 5,
        name: "Journal Entries",
        permissionName: "Journal Entries",
        show: false,
        showRoute: true,
        path: "/journal-entries/new",
        component: CreateJournalEntry,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 6,
        name: "Journal Entries",
        permissionName: "Journal Entries",
        show: false,
        showRoute: true,
        path: "/journal-entries/:id/edit",
        component: CreateJournalEntry,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 7,
        name: "Journal Entries",
        permissionName: "Journal Entries",
        show: false,
        showRoute: true,
        path: "/journal-entries/:id",
        component: CreateJournalEntry,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 8,
        name: "Financial Reports",
        permissionName: "Financial Reports",
        show: true,
        showRoute: true,
        path: "/financial-reports",
        component: FinancialReports,
        image: GeneralReportIcon,
        imageActive: GeneralReportIconActive
    },
    {
        index: 9,
        name: "Payroll Payments",
        show: true,
        showRoute: true,
        path: "/payroll-payments",
        component: PayrollPayments,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 10,
        name: "Payroll Payments",
        show: false,
        showRoute: true,
        path: "/payroll-payments/upload",
        component: PayrollPaymentUpload,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
    {
        index: 11,
        name: "Payroll Payments",
        show: false,
        showRoute: true,
        path: "/payroll-payments/:id",
        component: PayrollPayments,
        image: BalanceIcon,
        imageActive: BalanceIcon
    },
]
export default LedgerSideBar